<div class="main_wrapper">

  <h3 class="tool-title">
    <img class="bottom" src="/assets/img/tools/annotator.png" />
    {{
    sideNavService.annotationType === "create"
    ? "New Annotation"
    : "Edit Annotation"
    }}
  </h3>
    <input (keyup.enter)="create()" placeholder="Label" type="text" class="point_name" maxlength="100"
    [(ngModel)]="annotationData.name" />
  <li>
    <textarea style="height: 348px !important;" (keyup.enter)="create()" maxlength="1000" [(ngModel)]="annotationData.description" style="height: auto"
      rows="23" placeholder="Description" class="point_desc"></textarea>
  </li>
  <li style="border-top: 0.1px dotted rgb(177, 164, 164) !important;
  margin-top: 215px;">
    <form [formGroup]="annotationForm">
      <div formArrayName="user_fields">
        <div *ngFor="let employee of mapInfo().controls; let empIndex = index">
          <div [formGroupName]="empIndex">
            <input type="text" style="margin-top: 0px  !important;" placeholder="Label" formControlName="fieldname" />
              <quill-editor  formControlName="fieldname2"
              placeholder="Enter Text"
              [style]="editorStyle"
              [modules]="quillConfig"
              (onContentChanged)="onContentChanged($event)"></quill-editor>
          </div>
          <img *ngIf="!hideDeleteBin" style="width: 16px; margin-bottom: 5px;" src="../../../../../../assets/img/trash.svg" (click)="removeMapInfo(empIndex)" alt="trash">
        </div>
        <img style="width: 20px;" class="add-icon" src="../../../../../../assets/img/plus-border.png" alt="plus" (click)="addMaps()" />
      </div>
    </form>
  </li>


  <div style="height: auto; display: block" class="buttons save-btn" *ngIf="sideNavService.annotationType === 'create'">
    <a class="action save-annotation mytooltip" (click)="create()" [tooltip]="save" [options]="myOptions12">Save</a>
  </div>

  <div class="btn">
    <a [tooltip]="save" [options]="myOptions12" class="closer button">
      <img (click)="sideNavService.annotationType === 'create' ? create() : edit()" class="save-img common-btns"
        src="/assets/img/tools/save.png" alt="closer" /></a>

    <a class="closer button">
      <img (click)="closeRightpanel()" [tooltip]="mapService.templatetoolTips['close_right_panel']" [options]="myClose"
        class="closer-img common-btns" src="/assets/img/tools/close-pv3.png" alt="closer" /></a>
  </div>
</div>
